export {};

if (!customElements.get('details-modal')) {
  class DetailsModal extends HTMLElement {
    detailsContainer: HTMLDetailsElement;
    summaryToggle: HTMLElement;
    onBodyClickEvent?: (event: MouseEvent) => void;

    constructor() {
      super();
      this.detailsContainer = this.querySelector('details')!;
      this.summaryToggle = this.querySelector('summary')!;

      this.detailsContainer.addEventListener('keyup', (event: KeyboardEvent) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.querySelector<HTMLButtonElement>('button[type="button"]')?.addEventListener(
        'click',
        () => this.close()
      );

      this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen(): boolean {
      return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event: MouseEvent): void {
      event.preventDefault();
      (event.target as HTMLElement).closest('details')?.hasAttribute('open')
        ? this.close()
        : this.open(event);
    }

    onBodyClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;
      if (!this.contains(target) || target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event: MouseEvent): void {
      this.onBodyClickEvent = this.onBodyClickEvent ?? this.onBodyClick.bind(this);
      (event.target as HTMLElement).closest('details')?.setAttribute('open', 'true');
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden', '--no-scroll');

      trapFocus(
        this.detailsContainer.querySelector<HTMLElement>('[tabindex="-1"]')!,
        this.detailsContainer.querySelector<HTMLElement>('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true): void {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      if (this.onBodyClickEvent) document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden', '--no-scroll');
    }
  }

  customElements.define('details-modal', DetailsModal);
}
